import Style from "./loader.module.css";

export default function Loader(props: Omit<JSX.IntrinsicElements["div"], "className">) {
  return <div {...props} className={Style.loader} />;
}
